import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";
import Document from "./upload_documents/documents";

/**
 * Maindocument Component for displaying child Document.
 */
class MainDocument extends Component {
  render() {
    return (
      <Container
        style={{ maxWidth: "60%", marginTop: "40px !important" }}
        className="card container-card migrator-mt personalDetails-div-1"
      >
        <i
          className="material-icons contact-cancel-button pointer"
          onClick={this.props.back}
        >
          cancel
        </i>
        <Row>
          <Col md="12" className=" profile-contact-details-col mx-auto">
            <Document />
          </Col>
        </Row>
      </Container>
    );
  }
}

export default MainDocument;
